"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _reactRedux = require("react-redux");
var _config = require("../config");
var _ShoppingCartList = _interopRequireDefault(require("./ShoppingCartList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = function styles(theme) {
  return {
    cardShadow: {
      boxShadow: '4px 3px 20px #c7c7c7'
    }
  };
};

/**
 * We create our class by using injectToBaseContainer
 * this will return a React Component that is wrapped with the HOCs
 * inside flowRight, and hass all the props that are passed as options
 */
var _default = (0, _BaseInjectors.injectToBaseContainer)(_.flowRight((0, _styles.withStyles)(styles), (0, _reactRedux.connect)(function (state) {
  return {
    products: state.shoppingCartReducer.cart,
    kittyAmount: state.shoppingCartReducer.kittyAmount
  };
})), {
  listComponent: _ShoppingCartList.default,
  // Overrid componentDidMount of the BaseContainer to fetch the cart
  componentDidMount: function componentDidMount(props) {
    props.dispatch({
      type: 'FETCH_CART',
      params: {
        _embed: ['cart_items.salable_item']
      }
    });
  },
  headerTitle: 'Mon Panier',
  headerIcon: 'add_shopping_cart',
  confirmTitle: 'Êtes-vous sûr de vouloir procéder au paiement?',
  // Overrid the confirmation action of the ConfirmationDialog
  // NOTE: this NEEDS to be a function expression and NOT an arrow function
  confirmAction: function confirmAction() {
    var params;
    if (_config.KITTY_ENABLED) {
      var kittyAmount = this.props.kittyAmount;
      params = kittyAmount ? {
        kitty_wallet_amount: kittyAmount
      } : null;
    }
    if (_config.PAYMENT_METHOD === _config.PAYMENT_METHODS.MANGOPAY) {
      this.props.dispatch({
        type: 'PURCHASE',
        params: params
      });
    }
    if (_config.PAYMENT_METHOD === _config.PAYMENT_METHODS.INTERNAL_PAYMENT || _config.PAYMENT_METHOD === _config.PAYMENT_METHODS.INTERNAL_PAYMENT_WITH_STRIPE_CARD_ONLY) {
      this.props.dispatch({
        type: 'INTERNAL_PURCHASE',
        params: params
      });
    }
    this.closeConfirmDialog();
  }
});
exports.default = _default;